import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FeedbackHistoryRow from './FeedbackHistoryRow';
import './FeedbackHistory.scss';
var displayedStatuses = ['interview_requested', 'rejected', 'employer_accepted', 'submitted_to_employer', 'drafting'];
var renderRow = function renderRow(item) {
  return displayedStatuses.includes(item.new_status);
};
var tableHeading = /*#__PURE__*/React.createElement("tr", {
  className: "heading"
}, /*#__PURE__*/React.createElement("th", {
  colSpan: "4"
}, "Feedback"), /*#__PURE__*/React.createElement("th", {
  colSpan: "2"
}, "Status"), /*#__PURE__*/React.createElement("th", {
  colSpan: "2"
}, "User"), /*#__PURE__*/React.createElement("th", {
  colSpan: "2"
}, "Date"), /*#__PURE__*/React.createElement("th", {
  colSpan: "2"
}), /*#__PURE__*/React.createElement("th", {
  colSpan: "2"
}));
var FeedbackHistory = /*#__PURE__*/function (_Component) {
  function FeedbackHistory() {
    _classCallCheck(this, FeedbackHistory);
    return _callSuper(this, FeedbackHistory, arguments);
  }
  _inherits(FeedbackHistory, _Component);
  return _createClass(FeedbackHistory, [{
    key: "renderFeedbackItem",
    value: function renderFeedbackItem(item) {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        proposalResourceId = _this$props.proposalResourceId,
        consultant = _this$props.consultant,
        clorifyUrl = _this$props.clorifyUrl,
        reasonOptions = _this$props.reasonOptions,
        internalFeedbackText = _this$props.internalFeedbackText,
        advisorRemark = _this$props.advisorRemark;
      var type;
      var status;
      switch (item.new_status) {
        case 'interview_requested':
          type = 'interview';
          status = 'Interview Requested';
          break;
        case 'interview_in_progress':
          type = 'interview';
          status = 'Interview in Progress';
          break;
        case 'interview_completed':
          type = 'interview';
          status = 'Interview Completed';
          break;
        case 'rejected':
          type = 'decline';
          status = 'Declined';
          break;
        case 'employer_accepted':
          type = 'hire';
          status = 'Hired';
          break;
        case 'submitted_to_employer':
          type = 'submitted';
          status = 'Submitted';
          break;
        case 'drafting':
          type = 'drafting';
          status = 'Drafting';
          break;
        default:
          break;
      }
      return /*#__PURE__*/React.createElement(FeedbackHistoryRow, {
        item: item,
        csrfToken: csrfToken,
        proposalResourceId: proposalResourceId,
        consultant: consultant,
        clorifyUrl: clorifyUrl,
        reasonOptions: reasonOptions,
        key: item.id,
        type: type,
        status: status,
        internalFeedbackText: internalFeedbackText,
        advisorRemark: advisorRemark
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var feedbackItems = this.props.feedbackItems;
      return /*#__PURE__*/React.createElement("div", {
        className: "feedback-history-container"
      }, /*#__PURE__*/React.createElement("table", {
        className: "feedback-items-table"
      }, /*#__PURE__*/React.createElement("tbody", null, tableHeading, feedbackItems.map(function (item) {
        return renderRow(item) && _this.renderFeedbackItem(item);
      }))));
    }
  }]);
}(Component);
FeedbackHistory.propTypes = {
  feedbackItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  csrfToken: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string.isRequired,
  consultant: PropTypes.shape({}).isRequired,
  clorifyUrl: PropTypes.string.isRequired,
  internalFeedbackText: PropTypes.string,
  reasonOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advisorRemark: PropTypes.string
};
FeedbackHistory.defaultProps = {
  internalFeedbackText: null,
  advisorRemark: null
};
export default FeedbackHistory;